import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { Router} from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor(
	private _sharedService : SharedService,
	private _router : Router
  	) {
		// check token
		let token = this._sharedService.getCookie("auth_token");
		if (token) { // a session might exists. -> redirects to dashboard
			//this._sharedService.initUser(); 
			this._router.navigate(['/dashboard']);
		} 	

  	 }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/auth/auth.component.ts